import { makeStyles } from '@mui/styles';
import styled from "styled-components";

export const useStyles = makeStyles({
    page: {
        width:'100%'
    },
    comerce:{
        fontFamily: 'Open Sans',
        fontSize: '10px',
        marginTop: '-2%',
        textAlign: 'center'

    },

    headDate: {
        marginTop: '1.5%',
        marginLeft: '1%',
        fontFamily: 'Open Sans',
        fontSize: '10px',
    },

    titleComerce: {
        textAlign:'center'
    },
    summaryCode: {
        fontFamily: 'Open Sans',
        fontSize: '20px',
        marginLeft: '64px'

    },
    paymentDetail: {
        width: '76%',
        marginLeft: '10%',
        marginTop: '-2%'
    },

    paymentMethod:{
        width: '74%',
        marginLeft: '11%',
    },

    products: {
        width: '70%',
        marginLeft: '13%',
        background: '#f6f6f6'
    },

    address: {
        width: '76%',
        marginLeft: '10%',
        marginTop: '-2%'
    },

    titleDetail: {
        marginLeft: '16%',
        fontFamily: 'Open Sans',
        fontSize: '18px',
        color: '#222222'
    }, 
    icon: {
        position: 'absolute',
        marginLeft: '13.5%',
        marginTop: '4px'
    },
    headProducts: {
        fontFamily: 'Open Sans',
        fontSize: '10px',
        marginTop: '1%',
        marginLeft: '1%',
    },
    contact: {
        marginLeft: '16%',
        fontFamily: 'Open Sans',
        fontSize: '18px',
    }
});

const InfoCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 0.8rem;
    /* height: 90vh; */
    * {
        box-sizing: border-box;
    }
    
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        flex-direction: column;
        font-size: 1rem;
        word-break: break-all;
    }

    > div {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        flex: 1;
        height: auto;
    }
`;

const InfoCard = styled.div`
    background-color: #f6f6f6;
    width: 80%;
    overflow: hidden;
    margin: 0.8rem 1rem;
    border-radius: 3px;
    padding: 0.8rem 0.5rem;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        width: 90%;
    }
`;

const PurchaseResumeInfo = styled(InfoCard)`
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    & * {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0.25rem 0.5rem;
        font-weight: 500;
        @media (max-width: ${props => props.theme.breakpoints.md}) {
            margin: 0.5vh 0.5vh;
        }
    }
    #last {
        border-top: 1px solid #E2E2E2;
    }
`;

const PaymentInfo = styled(InfoCard)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    > div:first-child {
        min-width: 30%;
        max-width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        svg {
            width: 100%;
        }
    }
`;

const AddressInfo = styled(InfoCard)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    > div:first-child {
        min-width: 30%;
        max-width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        svg {
            width: 100%;
        }
    }
`;

const InvoiceContainer = styled.div`
`;

const ActionsInvoiceContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    margin: 1rem;
`;

const ActionButton = styled.button`
    border: none;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    outline: none;
    cursor: pointer;
`

const ProductsPurchasedContainer = styled.div`
    max-height: 60vh;
    overflow-y: auto;
    margin-right: 1rem;
    &::-webkit-scrollbar{
        width: 5px;
        
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 2.5px;
        background: #C4C4C4;
    }
    &::-webkit-scrollbar-track {
        border-radius: 2.5px;
        background: #F6F6F6;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        max-height: 50vh;
        margin-left: 0em;
    }

    @media print {
        margin-top: 10vh;
        height: auto;
        max-height: 1000vh;
        overflow-y: visible;
        page-break-inside: avoid;
    }
`

const ProductPurchasedCard = styled.div`
    display: flex;
    padding: 0.5rem 0.5rem;
    justify-content: flex-start;
    align-items: center;
    margin: 0rem 1rem;
`

const ProductPurchasedImage = styled.img`
    width: 20%;
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        width: 30%;
    }

`
const CancelButton = styled.a.attrs({ target:"_blank", rel:"noopener noreferrer"})`
    display: block;
    text-decoration: underline;
    font-weight: bold;
    font-size: 0.8em;
    text-align: center;
    margin-top: 10px;
    margin-right: auto;
    margin-left: auto;
    cursor: pointer;
    &:visited {
        color: black;
    }
    &:after{
        content: 'Cancelar';
    }
`

const ProductPurchasedInfo = styled.div`
    margin-left: 1rem;
    background: '#f6f6f6';
    .purchase-detail-product-reference {
        margin-top: 0;
        margin-bottom: 0.4rem;
        font-family: "Open Sans";
    }
`

const ErroContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
`

const PaymentMethodImg = styled.img`

`
const ButtonsActions = styled.div`
    text-align: center;
    padding-top: 1%;
    padding-bottom: 2%;
    
`

export {
    ActionButton,
    ActionsInvoiceContainer,
    AddressInfo,
    CancelButton,
    ErroContainer,
    InfoCardContainer,
    InvoiceContainer,
    PaymentInfo,
    PurchaseResumeInfo,
    ProductsPurchasedContainer,
    ProductPurchasedCard,
    ProductPurchasedImage,
    ProductPurchasedInfo,
    PaymentMethodImg,
    ButtonsActions
};